import React, { useContext, useEffect, useState } from "react";
import CarouselComponent from "./CarouselComponent";
import globalContext from "../context/global/globalContext";
import parse from "html-react-parser";
import {
  SET_ORDER_REQUEST_STATUS,
  SET_PARTICIPANTS_DATA,
  SET_CURRENT_HOTEL,
  SET_CURRENT_DURATION,
  SET_CURRENT_DATE,
  SET_CURRENT_TRANSPORT,
} from "../context/types";
import { useHistory } from "react-router-dom";
import { Button, Tab, Tabs, Box, Typography } from "@material-ui/core";
import HotelMetaComponent from "./HotelMetaComponent";
import HotelPreviewComponent from "./HotelPreviewComponent";
import HotelPriceComponent from "./HotelPriceComponent";
import HotelTravelDetailsComponent from "./HotelTravelDetailsComponent";
import { BRAND } from "../constants";
import GridOverlay from "./GridOverlay";
import { Info } from "@material-ui/icons";

const DetailsUcpaGrid = (props) => {
  const history = useHistory();
  const [tabIndex, setTabIndex] = useState(0);
  const [fetchingCombinations, setFetchingCombinations] = useState(false);
  const {
    currentTrip,
    fetchCombinations,
    currentCombinations,
    currentDestination,
    currentSubSeason,
    currentDuration,
    currentTransport,
    fetchOrderCreate,
  } = useContext(globalContext);

  const [dialogOpen, setDialogOpen] = useState(false);

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const [currentActivity, setCurrentActivity] = useState({});

  const { dispatch } = useContext(globalContext);

  const {
    destination_name,
    room_description,
    minimum_price,
    post,
    accomodation_code,
    period_id,
  } = currentTrip;

  var formatter = new Intl.NumberFormat("da-DK", {
    style: "currency",
    currency: "DKK",
  });

  useEffect(() => {
    if (
      currentTrip &&
      accomodation_code &&
      period_id &&
      !currentCombinations &&
      !fetchingCombinations
    ) {
      setFetchingCombinations(true);
      fetchCombinations(accomodation_code, period_id, false);
    }
    if (fetchingCombinations && currentCombinations) {
      setFetchingCombinations(false);
    }
  }, [
    fetchCombinations,
    fetchingCombinations,
    accomodation_code,
    period_id,
    currentTrip,
    currentCombinations,
  ]);

  const handleTabIndex = (event, newValue) => {
    setTabIndex(newValue);
  };
  const a11yProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  };

  const SoldOutButton = (combination) => {
    return (
      <div
        style={{ padding: "14px 12px" }}
        className="col-span-8 lg:col-span-1 font-normal text-sm text-center lg:text-center"
      >
        Udsolgt
      </div>
    );
  };

  const OrderButton = (props) => {
    const { combination } = props;

    return (
      <>
        {combination?.rooms?.room_on_request === 1 ? (
          <div className="col-span-12 lg:col-span-1 font-normal text-sm text-center lg:text-center mx-1 my-0">
            <Button
              style={{
                background: "#01a6c6",
                color: "#fff",
                borderRadius: 4,
                boxShadow: "none",
                padding: "12px 8px",
              }}
              className="w-full block"
              onClick={() => {
                dispatch({
                  type: SET_PARTICIPANTS_DATA,
                  payload: [],
                });
                dispatch({
                  type: SET_ORDER_REQUEST_STATUS,
                  payload: true,
                });
                dispatch({
                  type: SET_CURRENT_HOTEL,
                  payload: false,
                });

                fetchOrderCreate(combination.rooms.room_string);
                let combinationDate = new Date(
                  combination.current_week.departure_date
                ).getTime();
                history.push(
                  "order" +
                    "?destination_id" +
                    accomodation_code +
                    "&duration" +
                    currentDuration +
                    "&transport" +
                    currentTransport +
                    "&date=" +
                    combinationDate
                );
              }}
            >
              Forespørg
            </Button>
          </div>
        ) : (
          <div className="col-span-8 lg:col-span-1 font-normal text-sm text-center lg:text-center mx-1 my-0">
            <Button
              style={{
                background: "#01a6c6",
                color: "#fff",
                borderRadius: 4,
                boxShadow: "none",
                padding: "12px 8px",
              }}
              className="w-full block"
              onClick={() => {
                let combinationDate = new Date(
                  combination.current_week.departure_date
                ).getTime();

                dispatch({
                  type: SET_CURRENT_DATE,
                  payload: combinationDate,
                });

                dispatch({
                  type: SET_PARTICIPANTS_DATA,
                  payload: [],
                });
                dispatch({
                  type: SET_ORDER_REQUEST_STATUS,
                  payload: false,
                });
                dispatch({
                  type: SET_CURRENT_HOTEL,
                  payload: null,
                });

                fetchOrderCreate(combination.rooms.room_string);

                history.push(
                  "order" +
                    "?destination_id=" +
                    currentDestination.code +
                    "&duration=" +
                    currentDuration +
                    "&ages=30" +
                    "&transport=" +
                    currentTransport +
                    "&date=" +
                    combinationDate +
                    "&subseason=" +
                    currentSubSeason
                );
              }}
            >
              {formatter.format(combination.current_week.price)}
            </Button>
          </div>
        )}
      </>
    );
  };

  const TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  };

  return (
    <>
      <div className="relative mt-10 mb-10 p-6 border-4 border-gray-500 rounded bg-gray-100">
        <div className="grid mb-6 grid-cols-12">
          <div className="col-span-12 lg:col-span-7 mr-0 lg:mr-5 mb-4 lg:mb-0">
            {post && destination_name && room_description && minimum_price && (
              <HotelPreviewComponent
                post={post}
                trip={currentTrip}
                destination_name={destination_name}
                room_description={room_description}
                minimum_price={minimum_price}
                special={props.special}
              />
            )}
            <div className="travel-infobox rounded overflow-hidden mb-2 lg:mb-5 border border-gray-300">
              <h4 className="text-gray-800 text-center text-xs uppercase mb-0 font-semibold bg-gray-200 px-5  py-2">
                Detaljer
              </h4>

              {post?.meta && (
                <HotelMetaComponent trip={currentTrip} post={post} />
              )}
            </div>

            <div className="travel-infobox rounded overflow-hidden mb-2 lg:mb-5 border border-gray-300">
              <h4 className="text-gray-800 text-center text-xs uppercase mb-0 font-semibold bg-gray-200 px-5  py-2">
                Rejseinformation
              </h4>

              {post?.meta && <HotelTravelDetailsComponent trip={currentTrip} />}
            </div>
          </div>
          <div className={"col-span-12 lg:col-span-5"}>
            {post && destination_name && room_description && minimum_price && (
              <HotelPriceComponent
                post={post}
                trip={currentTrip}
                destination_name={destination_name}
                room_description={room_description}
                minimum_price={minimum_price}
              />
            )}
            {post?.meta?.gallery_settings && (
              <CarouselComponent
                className="rounded overflow-hidden"
                images={post.meta.gallery_settings}
                height="h-80 lg:h-96"
              />
            )}
          </div>
        </div>

        <div className="trip-options">
          <Tabs
            variant="scrollable"
            scrollButtons="on"
            value={tabIndex}
            onChange={handleTabIndex}
            aria-label="Muligheder"
          >
            <Tab
              style={{
                background: BRAND === "ucpa" ? "#01a6c6" : "#0e6c56",
                color: "#fff",
                marginRight: "0.333%",
                borderRadius: "3px",
                padding: "4px 6px",
              }}
              label="Priser"
              {...a11yProps(0)}
            />
            <Tab
              style={{
                background: BRAND === "ucpa" ? "#01a6c6" : "#0e6c56",
                color: "#fff",
                marginRight: "0.333%",
                borderRadius: "3px",
              }}
              label="Hotel"
              {...a11yProps(1)}
            />
            <Tab
              style={{
                background: BRAND === "ucpa" ? "#01a6c6" : "#0e6c56",
                color: "#fff",
                marginRight: "0.333%",
                borderRadius: "3px",
              }}
              label="Fakta"
              {...a11yProps(2)}
            />
            <Tab
              style={{
                background: BRAND === "ucpa" ? "#01a6c6" : "#0e6c56",
                color: "#fff",
                marginRight: "0",
                borderRadius: "3px",
              }}
              label="Kort"
              {...a11yProps(3)}
            />
          </Tabs>

          <TabPanel value={tabIndex} index={0}>
            {currentCombinations && (
              <>
                <div className="hidden lg:grid grid-cols-10 py-4 bg-gray-200">
                  <div className="col-span-5 px-4">
                    <div className="grid grid-cols-3 gap-x-2">
                      <Button
                        style={{
                          background:
                            currentTransport === "transport_0"
                              ? "#555555"
                              : "#aaaaaa",
                          color: "#fff",
                          borderRadius: 4,
                          boxShadow: "none",
                          padding: "12px 14px",
                        }}
                        className="w-full block"
                        onClick={() => {
                          dispatch({
                            type: SET_CURRENT_TRANSPORT,
                            payload: "transport_0",
                          });
                        }}
                      >
                        Kør selv
                      </Button>
                      <Button
                        style={{
                          background:
                            currentTransport === "transport_1"
                              ? "#555555"
                              : "#aaaaaa",
                          color: "#fff",
                          borderRadius: 4,
                          boxShadow: "none",
                          padding: "12px 14px",
                        }}
                        className="w-full block"
                        onClick={() => {
                          dispatch({
                            type: SET_CURRENT_TRANSPORT,
                            payload: "transport_1",
                          });
                        }}
                      >
                        Busrejser
                      </Button>
                      <Button
                        style={{
                          background:
                            currentTransport === "transport_2"
                              ? "#555555"
                              : "#aaaaaa",
                          color: "#fff",
                          borderRadius: 4,
                          boxShadow: "none",
                          padding: "12px 14px",
                        }}
                        className="w-full block"
                        onClick={() => {
                          dispatch({
                            type: SET_CURRENT_TRANSPORT,
                            payload: "transport_2",
                          });
                        }}
                      >
                        Flyrejser
                      </Button>
                    </div>
                  </div>
                  <div className="col-span-5 px-4">
                    <div className="grid grid-cols-3 gap-x-2">
                      <Button
                        style={{
                          background:
                            currentDuration === "3" ? "#555555" : "#aaaaaa",
                          color: "#fff",
                          borderRadius: 4,
                          boxShadow: "none",
                          padding: "12px 14px",
                        }}
                        className="w-full block"
                        onClick={() => {
                          dispatch({
                            type: SET_CURRENT_DURATION,
                            payload: "3",
                          });
                        }}
                      >
                        3 dage
                      </Button>
                      <Button
                        style={{
                          background:
                            currentDuration === "4" ? "#555555" : "#aaaaaa",
                          color: "#fff",
                          borderRadius: 4,
                          boxShadow: "none",
                          padding: "12px 14px",
                        }}
                        className="w-full block"
                        onClick={() => {
                          dispatch({
                            type: SET_CURRENT_DURATION,
                            payload: "4",
                          });
                        }}
                      >
                        4 dage
                      </Button>
                      <Button
                        style={{
                          background:
                            currentDuration === "7" ? "#555555" : "#aaaaaa",
                          color: "#fff",
                          borderRadius: 4,
                          boxShadow: "none",
                          padding: "12px 14px",
                        }}
                        className="w-full block"
                        onClick={() => {
                          dispatch({
                            type: SET_CURRENT_DURATION,
                            payload: "7",
                          });
                        }}
                      >
                        7 dage
                      </Button>
                    </div>
                  </div>
                </div>

                <div className="hidden lg:grid bg-white text-gray-900 border-b border-gray-400  grid-cols-10">
                  <div className="col-span-12 lg:col-span-5 font-semibold py-2 px-4 leading-8">
                    Beskrivelse
                  </div>
                  <div className="col-span-12 lg:col-span-1 text-center font-semibold py-2 px-4">
                    <h5 className="text-sm">
                      Uge {currentCombinations[0].dates[0]?.week}
                    </h5>
                    <h5 className="text-xs">
                      {currentCombinations[0].dates[0]?.date}
                    </h5>
                  </div>
                  <div className="col-span-12 lg:col-span-1 text-center font-semibold py-2 px-4">
                    <h5 className="text-sm">
                      Uge {currentCombinations[0].dates[1]?.week}
                    </h5>
                    <h5 className="text-xs">
                      {currentCombinations[0].dates[1]?.date}
                    </h5>
                  </div>
                  <div className="col-span-12 lg:col-span-1 text-center font-semibold py-2 px-4">
                    <h5 className="text-sm">
                      Uge {currentCombinations[0].dates[2]?.week}
                    </h5>
                    <h5 className="text-xs">
                      {currentCombinations[0].dates[2]?.date}
                    </h5>
                  </div>
                  <div className="col-span-12 lg:col-span-1 text-center font-semibold py-2 px-4">
                    <h5 className="text-sm">
                      Uge {currentCombinations[0].dates[3]?.week}
                    </h5>
                    <h5 className="text-xs">
                      {currentCombinations[0].dates[3]?.date}
                    </h5>
                  </div>
                  <div className="col-span-12 lg:col-span-1 text-center font-semibold py-2 px-4">
                    <h5 className="text-sm">
                      Uge {currentCombinations[0].dates[4]?.week}
                    </h5>
                    <h5 className="text-xs">
                      {currentCombinations[0].dates[4]?.date}
                    </h5>
                  </div>
                </div>
                {currentCombinations?.map((combination, index) => {
                  return (
                    combination.current?.rooms?.rooms_description && (
                      <div
                        key={index}
                        onClick={() => {
                          setCurrentActivity(combination.activity);
                          combination.activity
                            ? setDialogOpen(true)
                            : setDialogOpen(false);
                        }}
                        className={`${
                          combination.activity ? "cursor-pointer" : ""
                        } ${
                          index % 2 === 0 ? "bg-gray-200" : "bg-gray-50"
                        } grid grid-cols-10 py-2 px-0 mb-4 lg:mb-0 border-b-2`}
                      >
                        <div className="col-span-12 lg:col-span-5 py-2 px-4 font-bold lg:font-normal text-xs text-center lg:text-left leading-8">
                          {combination.current?.rooms?.rooms_description && (
                            <>
                              {combination.activity &&
                                combination.activity.meta
                                  .activity_product_short_description_translated && (
                                  <Info
                                    className="text-xs"
                                    style={{
                                      color: "rgb(1, 166, 198)",
                                      marginRight: 5,
                                    }}
                                  ></Info>
                                )}
                              {combination.current.rooms.rooms_description}
                            </>
                          )}
                        </div>
                        <div className="col-span-4 lg:col-span-1 lg:hidden text-left font-semibold py-2 px-4">
                          <h5 className="text-sm">
                            Uge {currentCombinations[0].dates[0]?.week}
                          </h5>
                          <h5 className="text-xs">
                            {currentCombinations[0].dates[0]?.date}
                          </h5>
                        </div>
                        {combination?.prev_2 ? (
                          <OrderButton combination={combination.prev_2} />
                        ) : (
                          <SoldOutButton combination={combination.prev_2} />
                        )}
                        <div className="col-span-4 lg:col-span-1 lg:hidden text-left font-semibold py-2 px-4">
                          <h5 className="text-sm">
                            Uge {currentCombinations[0].dates[1]?.week}
                          </h5>
                          <h5 className="text-xs">
                            {currentCombinations[0].dates[1]?.date}
                          </h5>
                        </div>
                        {combination?.prev_1 ? (
                          <OrderButton combination={combination.prev_1} />
                        ) : (
                          <SoldOutButton combination={combination.prev_1} />
                        )}
                        <div className="col-span-4 lg:col-span-1 lg:hidden text-left font-semibold py-2 px-4">
                          <h5 className="text-sm">
                            Uge {currentCombinations[0].dates[2]?.week}
                          </h5>
                          <h5 className="text-xs">
                            {currentCombinations[0].dates[2]?.date}
                          </h5>
                        </div>
                        {combination?.current ? (
                          <OrderButton combination={combination.current} />
                        ) : (
                          <SoldOutButton combination={combination.current} />
                        )}
                        <div className="col-span-4 lg:col-span-1 lg:hidden text-left font-semibold py-2 px-4">
                          <h5 className="text-sm">
                            Uge {currentCombinations[0].dates[3]?.week}
                          </h5>
                          <h5 className="text-xs">
                            {currentCombinations[0].dates[3]?.date}
                          </h5>
                        </div>
                        {combination?.next_1 ? (
                          <OrderButton combination={combination.next_1} />
                        ) : (
                          <SoldOutButton combination={combination.next_1} />
                        )}
                        <div className="col-span-4 lg:col-span-1 lg:hidden text-left font-semibold py-2 px-4">
                          <h5 className="text-sm">
                            Uge {currentCombinations[0].dates[4]?.week}
                          </h5>
                          <h5 className="text-xs">
                            {currentCombinations[0].dates[4]?.date}
                          </h5>
                        </div>
                        {combination?.next_2 ? (
                          <OrderButton combination={combination.next_2} />
                        ) : (
                          <SoldOutButton combination={combination.next_2} />
                        )}
                      </div>
                    )
                  );
                })}
              </>
            )}
          </TabPanel>

          <TabPanel className="pt-4" value={tabIndex} index={1}>
            {post?.description && <div>{parse(post?.description)}</div>}
          </TabPanel>

          <TabPanel className="pt-4" value={tabIndex} index={2}>
            {post?.meta?.hotel_fakta && (
              <div
                className={`${
                  tabIndex === 2 ? "block" : "hidden"
                } hotel_beliggenhed`}
              >
                <HotelMetaComponent trip={currentTrip} post={post} />
              </div>
            )}
          </TabPanel>
          <TabPanel className="pt-4" value={tabIndex} index={3}>
            {post?.location && <div>{parse(post?.location)}</div>}
          </TabPanel>
        </div>
      </div>
      {!props.singular && (
        <div className="text-center">
          <h6
            style={{ borderColor: BRAND === "ucpa" ? "#01a6c6" : "#0e6c56" }}
            className="px-8 py-2 text-base inline-block text-center uppercase font-bold border-2 text-gray-600 my-8 rounded"
          >
            Alternative rejsemuligheder
          </h6>
        </div>
      )}
      <GridOverlay
        onClose={handleDialogClose}
        open={dialogOpen}
        activity={currentActivity}
      />
    </>
  );
};

export default DetailsUcpaGrid;
